import React, { useRef, useState } from 'react';
import './ProfileContent.css';

// Иконки
const EditIcon = () => (
  <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L8.5 8.5L1 16" stroke="#0f0f0f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const SaveIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#0f0f0f"/>
  </svg>
);

const CancelIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="#838383"/>
  </svg>
);

const MailIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="#727272"/>
  </svg>
);

const ProfileContent = ({ 
  gameName = 'BRAWLSTARS',
  gameImage = '/images/game-avatar.jpg',
  userName = 'BRAWLSTARS',
  userEmail = 'brawlstars564562f@gmail.com',
  onEditName,
  onEditEmail,
  onUploadAvatar,
  // Edit mode props
  isEditingName = false,
  isEditingEmail = false,
  newName = '',
  newEmail = '',
  onNameChange,
  onEmailChange,
  onSaveName,
  onSaveEmail,
  onCancelEdit,
  loading = false,
  error = null,
  successMessage = null
}) => {
  const avatarInputRef = useRef(null);
  const [uploadingAvatar, setUploadingAvatar] = useState(false);
  const [avatarUrl, setAvatarUrl] = useState(gameImage);

  // Обновляем URL аватара при изменении gameImage
  React.useEffect(() => {
    // Добавляем timestamp для предотвращения кэширования
    const timestamp = new Date().getTime();
    setAvatarUrl(`${gameImage}?t=${timestamp}`);
  }, [gameImage]);

  const handleAvatarClick = () => {
    avatarInputRef.current?.click();
  };

  const handleAvatarChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Проверяем тип файла
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      alert('Неподдерживаемый формат файла. Разрешены: JPEG, PNG, GIF, WEBP');
      return;
    }

    // Проверяем размер файла (максимум 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('Файл слишком большой. Максимальный размер: 5MB');
      return;
    }

    setUploadingAvatar(true);
    try {
      if (onUploadAvatar) {
        await onUploadAvatar(file);
      }
    } catch (error) {
      console.error('Error uploading avatar:', error);
      alert('Ошибка при загрузке аватара');
    } finally {
      setUploadingAvatar(false);
      // Очищаем input для возможности повторной загрузки того же файла
      e.target.value = '';
    }
  };
  return (
    <div className="profile-content">
      {/* Messages */}
      {error && (
        <div className="profile-content__message profile-content__message--error">
          {error}
        </div>
      )}
      {successMessage && (
        <div className="profile-content__message profile-content__message--success">
          {successMessage}
        </div>
      )}

      {/* Секция игры */}
      <div className="profile-content__game">
        <div 
          className="profile-content__game-avatar"
          onClick={handleAvatarClick}
          title="Нажмите, чтобы изменить фото"
        >
          <div className="profile-content__game-image">
            <img 
              src={avatarUrl} 
              alt={gameName}
              key={avatarUrl}
            />
            <div className="profile-content__avatar-overlay">
              {uploadingAvatar ? (
                <div className="profile-content__avatar-spinner" />
              ) : (
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16 13H13V16C13 16.55 12.55 17 12 17C11.45 17 11 16.55 11 16V13H8C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11H11V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V11H16C16.55 11 17 11.45 17 12C17 12.55 16.55 13 16 13Z" fill="white"/>
                </svg>
              )}
            </div>
          </div>
        </div>
        <input
          ref={avatarInputRef}
          type="file"
          accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
          onChange={handleAvatarChange}
          style={{ display: 'none' }}
        />
        <div className="profile-content__game-info">
          <div className="profile-content__game-header">
            <h3 className="profile-content__game-name">{gameName}</h3>
          </div>
        </div>
      </div>

      {/* Секция редактирования */}
      <div className="profile-content__edit-section">
        <div className="profile-content__edit-row">
          {isEditingName ? (
            <div className="profile-content__edit-input-wrapper">
              <input
                type="text"
                className="profile-content__edit-input"
                value={newName}
                onChange={(e) => onNameChange?.(e.target.value)}
                placeholder="Введите имя"
                disabled={loading}
              />
              <button 
                className="profile-content__edit-action profile-content__edit-action--save"
                onClick={onSaveName}
                disabled={loading}
              >
                <SaveIcon />
              </button>
              <button 
                className="profile-content__edit-action profile-content__edit-action--cancel"
                onClick={onCancelEdit}
                disabled={loading}
              >
                <CancelIcon />
              </button>
            </div>
          ) : (
            <button className="profile-content__edit-btn profile-content__edit-btn--primary" onClick={onEditName}>
              <EditIcon />
              <span>Изменить имя</span>
            </button>
          )}
          
          {isEditingEmail ? (
            <div className="profile-content__edit-input-wrapper">
              <input
                type="email"
                className="profile-content__edit-input"
                value={newEmail}
                onChange={(e) => onEmailChange?.(e.target.value)}
                placeholder="Введите email"
                disabled={loading}
              />
              <button 
                className="profile-content__edit-action profile-content__edit-action--save"
                onClick={onSaveEmail}
                disabled={loading}
              >
                <SaveIcon />
              </button>
              <button 
                className="profile-content__edit-action profile-content__edit-action--cancel"
                onClick={onCancelEdit}
                disabled={loading}
              >
                <CancelIcon />
              </button>
            </div>
          ) : (
            <button className="profile-content__edit-btn profile-content__edit-btn--primary" onClick={onEditEmail}>
              <EditIcon />
              <span>Изменить электронную почту</span>
            </button>
          )}
        </div>
        <div className="profile-content__edit-row">
          <div className="profile-content__display-field">
            <span>{userName}</span>
          </div>
          <div className="profile-content__display-field">
            <MailIcon />
            <span>{userEmail.toLowerCase()}</span>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ProfileContent;
